<template>
  <div class="mainWrapper">
    <div class="inner" ref="inner">
      <defaultBar />
      <template v-for="(list, index) in latestNews" :key="index">
        <component
          :is="
            list.length !== pageSize
              ? 'universalList'
              : `bar${index.toString().substr(-1)}`
          "
          :list="list"
          transition-mode="out-in"
        />
      </template>
    </div>
    <div
      v-if="showSpinner"
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 44px 0;
      "
      :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
    >
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch } from "vue";
import AdditionalBar from "@/components/AdditionalBar";
import MainBar from "@/components/uzbekistan/MainBar";
import FirstBar from "@/components/uzbekistan/FirstBar";
import SecondBar from "@/components/uzbekistan/SecondBar";
import ThirdBar from "@/components/uzbekistan/ThirdBar";
import FourthBar from "@/components/uzbekistan/FourthBar";
import FivthBar from "@/components/uzbekistan/FivthBar";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useStore } from "vuex";
import { useLanguage } from '@/utils/language'

export default {
  components: {
    defaultBar: MainBar,

    universalList: AdditionalBar,

    bar0: FirstBar,
    bar1: SecondBar,
    bar2: ThirdBar,
    bar3: FourthBar,
    bar4: FivthBar,

    bar5: FirstBar,
    bar6: SecondBar,
    bar7: ThirdBar,
    bar8: FourthBar,
    bar9: FivthBar,
  },
  setup() {
    const store = useStore();
    const pageSize = 8; // Number of elements per Bar
    const inner = ref(null);
    const showSpinner = ref(true);
    const scrollEnd = () => {
      showSpinner.value = false
    };
    const { i18n } = useLanguage()
    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: 'uzbekistan',
          load,
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd,
    });
    const refreshData = () => {
      // Necessary to empty the news feed when
      // routing through pages
      store.commit("flushArticleState");
      store.commit("flushUzbekistanNews");
      startInfiniteScroll();
      showSpinner.value = true
      loadData();
    };

    refreshData()

    watch(() => i18n.global.locale.value, refreshData);

    return {
      inner,
      pageSize,
      showSpinner,
      latestNews: computed(() => store.getters.latestNews),
    };
  },
};
</script>


<style lang="scss" scoped>
.mainWrapper {
  // colors
  --date: rgba(212, 212, 212, 1);
  --date-grey: rgba(107, 107, 107, 1);
  --title-black: rgba(27, 27, 27, 1);
  --p-black: rgba(55, 55, 55, 1);
  --category: rgba(73, 73, 73, 1);
  --p-grey: rgba(58, 58, 58, 1);
  --p-mobile: rgba(109, 109, 109, 1);

  // background
  --grey-six: rgba(12, 12, 12, 0.65);
  --light: rgba(255, 255, 255, 1);
  --light-seven: rgba(255, 255, 255, 0.7);
  --light-six: rgba(255, 255, 255, 0.6);
  --black: rgba(18, 18, 18, 1);
  --black-seven: rgba(18, 18, 18, 0.7);
  --black-eight: rgba(18, 18, 18, 0.8);
  --content-bg: rgba(72, 72, 72, 1);

  --black-six: rgba(18, 18, 18, 0.6);
  --second-bg: #e9e9e9;

  color: var(--light);
}
</style>
